"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _iconsReact = require("../../../../icons-react");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PLACEHOLDER = 'ID пакета';
var NOT_NUMBERIC_REGEX = /\D+/g;
var PackageSearch = /*#__PURE__*/function (_React$PureComponent) {
  function PackageSearch(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PackageSearch);
    _this = _callSuper(this, PackageSearch, [props]);
    _this.state = {
      value: ''
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(PackageSearch, _React$PureComponent);
  return (0, _createClass2["default"])(PackageSearch, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var currentTarget = _ref.currentTarget;
      var unformattedValue = currentTarget.value;
      var value = unformattedValue.replace(NOT_NUMBERIC_REGEX, '');
      this.setState({
        value: value
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(_ref2) {
      var key = _ref2.key;
      if (key === 'Escape') {
        this.handleReset();
      }
      if (key === 'Enter') {
        this.handleSubmit();
      }
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      this.setState({
        value: ''
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var onSearch = this.props.onSearch;
      var value = this.state.value;
      onSearch({
        value: value
      });
      this.handleReset();
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(this.props), this.props));

      // Fixes test warnings.
      delete props.onSearch;
      return /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledPackageSearch, (0, _extends2["default"])({}, props, {
        value: value,
        placeholder: PLACEHOLDER,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown
      })), /*#__PURE__*/_react["default"].createElement(StyledArrowEnterIcon, null));
    }
  }]);
}(_react["default"].PureComponent);
PackageSearch.propTypes = {
  className: _propTypes["default"].string,
  onSearch: _propTypes["default"].func
};
PackageSearch.defaultProps = {
  className: '',
  onSearch: Function.prototype
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PackageSearch__StyledWrapper",
  componentId: "sc-1dg7ija-0"
})(["position:relative;"]);
var StyledPackageSearch = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "PackageSearch__StyledPackageSearch",
  componentId: "sc-1dg7ija-1"
})(["border-radius:4px;border:solid 1px #c2c5cc;font-size:13px;height:40px;padding-right:25px;width:116px;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}"]);
var StyledArrowEnterIcon = (0, _styledComponents["default"])(_iconsReact.ArrowEnter).withConfig({
  displayName: "PackageSearch__StyledArrowEnterIcon",
  componentId: "sc-1dg7ija-2"
})(["width:10px;height:18px;margin-top:-9px;position:absolute;right:10px;top:50%;"]);
var _default = exports["default"] = PackageSearch;